import { useMutation } from "@tanstack/react-query";
import { useState } from "react";
import { api } from "../api.ts";
import { Button, ErrorText, Textarea } from "../ui.tsx";

/**
 * "Did ninekeep get this right?": a thumbs up, or a thumbs down with what was wrong. It goes to
 * ninekeep's team as an example of how the AI did; it changes nothing here.
 */
export function AiFeedback({
  task,
  refId,
  question,
}: {
  task: "contract" | "letter" | "dispute" | "reply";
  refId: string;
  question: string;
}) {
  const [down, setDown] = useState(false);
  const [note, setNote] = useState("");
  const send = useMutation({
    mutationFn: (verdict: "thumbs_up" | "thumbs_down") =>
      api.post("/ai-feedback", { task, refId, verdict, note: note.trim() || null }),
  });
  if (send.isSuccess)
    return <p className="text-sm text-muted">Thanks. ninekeep's team reads every one of these.</p>;
  return (
    <div className="flex flex-col gap-2 text-sm">
      <div className="flex flex-wrap items-center gap-2">
        <span className="text-muted">{question}</span>
        <Button
          variant="ghost"
          aria-label="Yes, it got this right"
          busy={send.isPending && send.variables === "thumbs_up"}
          onClick={() => send.mutate("thumbs_up")}
        >
          👍 Yes
        </Button>
        <Button
          variant="ghost"
          aria-label="No, something's wrong"
          aria-expanded={down}
          onClick={() => setDown(!down)}
        >
          👎 No
        </Button>
      </div>
      {down && (
        <div className="flex flex-col gap-2 sm:max-w-xl">
          <Textarea
            aria-label="What did ninekeep get wrong?"
            rows={2}
            placeholder="What did ninekeep get wrong? (optional)"
            value={note}
            onChange={(e) => setNote(e.target.value)}
          />
          <div>
            <Button busy={send.isPending} onClick={() => send.mutate("thumbs_down")}>
              Send
            </Button>
          </div>
        </div>
      )}
      <ErrorText error={send.error} />
    </div>
  );
}
